export const actions = {
    REQ_GET_TESTS: 'REQ_GET_TESTS',
    SET_TESTS: 'SET_TESTS',
}

export const reqGetTests = () => ({ type: actions.REQ_GET_TESTS })
export const setTests = (tests) => ({ type: actions.SET_TESTS, tests })

export default actions
